// utils/crypto/buffer.ts 

// ------------------------------------------------------------------------------
export function u8ToArrayBuffer(u8: Uint8Array): ArrayBuffer {
  const buf = u8.buffer;
  const hasShared = typeof SharedArrayBuffer !== "undefined";
  const isShared = hasShared && buf instanceof SharedArrayBuffer;

  // Zero-copy if safe (not Shared, full coverage)
  if (!isShared && u8.byteOffset === 0 && u8.byteLength === buf.byteLength) {
    return buf as ArrayBuffer;
  }

  // Copy into a fresh ArrayBuffer (guaranteed ArrayBuffer)
  const ab = new ArrayBuffer(u8.byteLength);
  new Uint8Array(ab).set(u8);
  return ab;
}
